import { render } from "./getConsultation.vue?vue&type=template&id=1e946804&scoped=true"
import script from "./getConsultation.vue?vue&type=script&lang=js"
export * from "./getConsultation.vue?vue&type=script&lang=js"

import "./getConsultation.vue?vue&type=style&index=0&id=1e946804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e946804"]])

export default __exports__